import { StorageManager } from "./StorageManager";
import { StoragePriority } from "./StoragePriority";

/**
 * Public API for the Storage Management system.
 */

export * from "./StoragePriority";
export * from "./QuotaMonitor";

/**
 * Safe version of localStorage.setItem.
 */
export function safeSetItem(
  key: string,
  value: string,
  priority?: StoragePriority,
  silent: boolean = false
): boolean {
  return StorageManager.getInstance().setItem(key, value, priority, silent);
}

/**
 * Safe version of localStorage.getItem.
 */
export function safeGetItem(key: string): string | null {
  return StorageManager.getInstance().getItem(key);
}

/**
 * Safe version of localStorage.removeItem.
 */
export function safeRemoveItem(key: string): void {
  StorageManager.getInstance().removeItem(key);
}

/**
 * Get quota statistics.
 */

export function getStorageStats() {
  return StorageManager.getInstance().getQuotaInfo();
}

// Only export tests in development
if (process.env.NODE_ENV === "development") {
  require("./storageTests");
}

/**
 * Export singleton instance for advanced usage.
 */
export const storageManager = StorageManager.getInstance();
